import styled from 'styled-components';
import { renderDescriptionInput, renderExpectationItem, renderPasswordInput, renderShuffleQuestionOption, renderTitleInput, renderEnableSecurityOptionSwitchOption, renderSecurityOptionSelection, renderAutoBanOptions, renderShuffleAnswerOption, renderShowExplanationRadioOptions, renderDurationInput, renderShowExplanationSwitchOption } from './base-options.component';
import { FieldLabel, SectionHeader } from '../field-label.component';
import { Form } from 'antd';
import { useEffect, useState } from 'react';
import { TextToHTMLTransformerComponent, TextLinkButton, WindowEdit, styleVariables, getSize, getColor, DefaultRangePicker, RichTextEditor } from '@lib/common';
import { CheckSquareOutlined } from '@ant-design/icons';
import { disabledDate, disabledTime } from '../../utils/getPastTime';
import moment from 'moment';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledSecurityOptionsContainer = styled.div.withConfig({
  displayName: "create-examination-optionscomponent__StyledSecurityOptionsContainer",
  componentId: "sc-1439gqc-0"
})(["margin:0 8px;"]);
var StyledTermsAndConditionHeader = styled.div.withConfig({
  displayName: "create-examination-optionscomponent__StyledTermsAndConditionHeader",
  componentId: "sc-1439gqc-1"
})(["width:100%;display:flex;justify-content:space-between;align-items:center;"]);
var StyledTermsAndConditionsButton = styled(TextLinkButton).withConfig({
  displayName: "create-examination-optionscomponent__StyledTermsAndConditionsButton",
  componentId: "sc-1439gqc-2"
})(["display:flex;gap:5px;align-items:center;color:", ";span{margin:0;font-weight:500;}"], styleVariables.colors.primary60);
var StyledTermsAndConditionLabel = styled.span.withConfig({
  displayName: "create-examination-optionscomponent__StyledTermsAndConditionLabel",
  componentId: "sc-1439gqc-3"
})(["font-size:", ";font-weight:500;"], styleVariables.font.fontSizeSmall);
var StyledTermsAndConditionsContentContainer = styled.div.withConfig({
  displayName: "create-examination-optionscomponent__StyledTermsAndConditionsContentContainer",
  componentId: "sc-1439gqc-4"
})(["padding:12px;border-radius:", ";border:1px solid ", ";height:180px;overflow-y:auto;"], styleVariables.borderRadius.medium, styleVariables.colors.grey70);
var StyledTermsAndConditionsContent = styled(TextToHTMLTransformerComponent).withConfig({
  displayName: "create-examination-optionscomponent__StyledTermsAndConditionsContent",
  componentId: "sc-1439gqc-5"
})(["font-weight:400;font-size:", ";letter-spacing:0;line-height:", ";color:", ";cursor:pointer;p{margin:0;}img{max-width:100%;}"], getSize('typo14'), getSize('padding20'), getColor('contentTitle'));
var StyledRichTextEditor = styled(RichTextEditor).withConfig({
  displayName: "create-examination-optionscomponent__StyledRichTextEditor",
  componentId: "sc-1439gqc-6"
})(["height:180px;"]);
var StyledWrapper = styled.div.withConfig({
  displayName: "create-examination-optionscomponent__StyledWrapper",
  componentId: "sc-1439gqc-7"
})(["background-color:", ";padding:16px;border:1px solid #e6e8f0;border-radius:8px;margin-bottom:16px;"], getColor('fillBgSub'));
var StyledTermsHint = styled.div.withConfig({
  displayName: "create-examination-optionscomponent__StyledTermsHint",
  componentId: "sc-1439gqc-8"
})(["margin-bottom:6px;font-size:11px;line-height:1.35;color:", ";"], styleVariables.colors.gray10);
export var CreateExaminationOptions = function CreateExaminationOptions(props) {
  var label = props.label,
      errorLabel = props.errorLabel,
      securityOptions = props.securityOptions,
      isLoadingGetSecurityOptions = props.isLoadingGetSecurityOptions,
      form = props.form,
      editorLabels = props.editorLabels,
      formTotalScore = props.formTotalScore,
      onFormValuesChange = props.onFormValuesChange,
      _props$mode = props.mode,
      mode = _props$mode === void 0 ? 'create' : _props$mode,
      passwordContent = props.passwordContent,
      participationFields = props.participationFields;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(StyledWrapper, {
      children: [/*#__PURE__*/_jsx(SectionHeader, {
        title: label.basicInformation,
        description: label.basicInformationDescription
      }), renderTitleInput(label, errorLabel), renderDescriptionInput(label)]
    }), /*#__PURE__*/_jsxs(StyledWrapper, {
      children: [/*#__PURE__*/_jsx(SectionHeader, {
        title: label.timeAndAttempts,
        description: label.timeAndAttemptsDescription
      }), renderDurationInput(label, errorLabel), /*#__PURE__*/_jsx(Form.Item, {
        label: /*#__PURE__*/_jsx(FieldLabel, {
          label: label.deadline,
          hint: label.deadlineHint,
          required: true
        }),
        name: "rangeDate",
        initialValue: mode === 'create' ? [moment().add(10, 'minutes'), moment().add(40, 'minutes')] : undefined,
        dependencies: ['duration'],
        rules: [{
          required: true,
          message: errorLabel.selectDeadlineMessage
        }],
        children: /*#__PURE__*/_jsx(DefaultRangePicker, {
          disabledDate: mode === 'edit' ? undefined : disabledDate,
          disabledTime: mode === 'edit' ? undefined : disabledTime,
          showTime: {
            format: 'HH:mm'
          },
          format: "DD/MM/YYYY - HH:mm",
          placeholder: [label.startTime, label.endTime],
          onChange: function onChange(dates) {
            if (dates && dates.length === 2) {
              form.validateFields(['duration']);
            }
          }
        })
      })]
    }), /*#__PURE__*/_jsxs(StyledWrapper, {
      children: [/*#__PURE__*/_jsx(SectionHeader, {
        title: label.shuffleSettings,
        description: label.shuffleSettingsDescription
      }), renderShuffleQuestionOption(label), renderShuffleAnswerOption(label)]
    }), /*#__PURE__*/_jsxs(StyledWrapper, {
      children: [/*#__PURE__*/_jsx(SectionHeader, {
        title: label.shareAndAccess,
        description: label.shareAndAccessDescription
      }), participationFields, passwordContent !== null && passwordContent !== void 0 ? passwordContent : renderPasswordInput(label, errorLabel)]
    }), /*#__PURE__*/_jsxs(StyledWrapper, {
      children: [/*#__PURE__*/_jsx(SectionHeader, {
        title: label.scoringAndResults,
        description: label.scoringAndResultsDescription
      }), renderShowExplanationRadioOptions(label, errorLabel), renderShowExplanationSwitchOption(label), renderExpectationItem(label, errorLabel, true, formTotalScore, mode === 'edit' ? undefined : onFormValuesChange)]
    }), /*#__PURE__*/_jsxs(StyledWrapper, {
      children: [/*#__PURE__*/_jsx(SectionHeader, {
        title: label.securityOptions,
        description: label.securityOptionsDescription
      }), renderEnableSecurityOptionSwitchOption(label), /*#__PURE__*/_jsxs(StyledSecurityOptionsContainer, {
        children: [renderAutoBanOptions(label, errorLabel), renderSecurityOptionSelection(isLoadingGetSecurityOptions, errorLabel, label, securityOptions), /*#__PURE__*/_jsx(TermsAndConditions, {
          label: label,
          editorLabels: editorLabels,
          form: form,
          mode: mode,
          onFormValuesChange: onFormValuesChange
        })]
      })]
    })]
  });
};

var TermsAndConditions = function TermsAndConditions(_ref) {
  var label = _ref.label,
      editorLabels = _ref.editorLabels,
      form = _ref.form,
      mode = _ref.mode,
      onFormValuesChange = _ref.onFormValuesChange;

  var _useState = useState(false),
      isEditing = _useState[0],
      setIsEditing = _useState[1];

  var hasSecurityOptions = Form.useWatch('hasSecurityOptions', form) === true;
  var content = Form.useWatch('termsAndConditions', form);
  useEffect(function () {
    if (mode === 'create' && content === undefined) {
      form.setFieldValue('termsAndConditions', label.defaultTermsAndConditions);
    }
  }, [content, form, label.defaultTermsAndConditions, mode]);
  useEffect(function () {
    if (!hasSecurityOptions) setIsEditing(false);
  }, [hasSecurityOptions]);

  var handleEditorChangeText = function handleEditorChangeText(value) {
    form.setFieldValue('termsAndConditions', value);
    onFormValuesChange === null || onFormValuesChange === void 0 ? void 0 : onFormValuesChange();
  };

  var toggleEditing = function toggleEditing() {
    return setIsEditing(function (previous) {
      return !previous;
    });
  };

  var renderLabel = function renderLabel() {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(StyledTermsAndConditionHeader, {
        children: [/*#__PURE__*/_jsx(StyledTermsAndConditionLabel, {
          children: label.termsAndConditions
        }), /*#__PURE__*/_jsxs(StyledTermsAndConditionsButton, {
          onClick: toggleEditing,
          children: [isEditing ? /*#__PURE__*/_jsx(CheckSquareOutlined, {
            color: styleVariables.colors.primary60
          }) : /*#__PURE__*/_jsx(WindowEdit, {}), /*#__PURE__*/_jsx("span", {
            children: isEditing ? label.complete : label.edit
          })]
        })]
      }), label.termsAndConditionsHint ? /*#__PURE__*/_jsx(StyledTermsHint, {
        children: label.termsAndConditionsHint
      }) : null]
    });
  };

  if (!hasSecurityOptions) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderLabel(), /*#__PURE__*/_jsx(Form.Item, {
      name: "termsAndConditions",
      children: isEditing ? /*#__PURE__*/_jsx(StyledRichTextEditor, {
        onChange: handleEditorChangeText,
        content: content !== null && content !== void 0 ? content : '',
        editorLabels: editorLabels,
        scrollable: true
      }) : /*#__PURE__*/_jsx(StyledTermsAndConditionsContentContainer, {
        children: /*#__PURE__*/_jsx(StyledTermsAndConditionsContent, {
          value: content !== null && content !== void 0 ? content : ''
        })
      })
    })]
  });
};